<div class="navbar-container">
  <a class="home-link" [routerLink]="['']">
    <app-mira-logo class="brand-logo" [width]="36" [height]="36" />
    <span class="brand-name"><span class="brand-box">box</span><span class="brand-dot">.</span><span class="brand-moe">moe</span></span>
  </a>
  <app-search></app-search>
  <div class="right-side-wrapper">
    <app-theme-toggle />
    <ng-content></ng-content>
  </div>
</div>
